import { initializeFaro, SessionInstrumentation } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

import { environment } from '../environments/environment'

export function initializeFaroRUM(): void {
	if (!environment.OTEL_ENABLED || !environment.FARO_URL) return
	initializeFaro({
		url: environment.FARO_URL,
		app: {
			name: 'mobile',
			version: '1.0.0',
			environment: environment.environment,
		},
		instrumentations: [
			new SessionInstrumentation(),
			new TracingInstrumentation({
				instrumentationOptions: {
					propagateTraceHeaderCorsUrls: environment.tracePropagationTargets,
				},
			}),
		],
	})
}
